export function FormHeader({ titleId, title, description }) {
  return (
    <div className="border-b border-grid pb-8">
      <h2 id={titleId} className="text-2xl font-extrabold tracking-tight text-graphite sm:text-3xl">
        {title}
      </h2>
      {description ? <p className="mt-2 leading-relaxed text-steel">{description}</p> : null}
    </div>
  );
}